<template>
  <nav class="navbar navbar-expand-lg navbar-light navbar-home">
    <div class="container">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 ">
          <!-- ข้อมูลบริษัท -->
          <li class="nav-item dropdown">
            <a class="nav-link" href="#" id="financialInfoDropdown" role="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              {{ $t('navbar.companyInfo') }}
            </a>
            <ul class="dropdown-menu shadow-dropdown" aria-labelledby="financialInfoDropdown">
              <li><a class="dropdown-item" href="https://origin.co.th/corporate/about-origin-property/">{{
                $t('navbar.AboutOrigin') }}</a></li>
              <li><a class="dropdown-item" href="https://origin.co.th/corporate/company-history/">{{ $t('navbar.History')
              }}</a></li>
              <li><a class="dropdown-item" href="https://origin.co.th/corporate/message-from-the-chairman/">{{
                $t('navbar.ChairmanMessage') }}</a></li>
              <li><a class="dropdown-item" href="https://origin.co.th/corporate/message-from-the-ceo/">{{
                $t('navbar.CEOMessage') }}</a></li>
              <li><a class="dropdown-item" href="https://origin.co.th/corporate/organization-chart/">{{
                $t('navbar.OrgChart') }}</a></li>
              <li><a class="dropdown-item" href="https://origin.co.th/corporate/group-structure/">{{
                $t('navbar.GroupStructure') }}</a></li>
              <li><a class="dropdown-item" href="https://origin.co.th/corporate/board-of-directors/">{{
                $t('navbar.ManagementStructure') }}</a></li>
              <li><a class="dropdown-item" href="https://origin.co.th/corporate/awards-received/">{{ $t('navbar.Awards')
              }}</a></li>
              <li><a class="dropdown-item"
                  href="https://origin.co.th/corporate/about-origin-property/corporate-governance/cg-policy/">{{
                    $t('navbar.CorporateGovernance') }}</a></li>
              <!-- <li><a class="dropdown-item"
                  href="https://origin.co.th/corporate/about-origin-property/driving-business/sustainability-management/">{{
                    $t('navbar.Sustainability') }}</a></li> -->
            </ul>
          </li>

          <!-- ข้อมูลทางการเงิน -->
          <li class="nav-item dropdown">
            <a class="nav-link" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              {{ $t('navbar.FinancialInfo') }}
            </a>
            <ul class="dropdown-menu shadow-dropdown">
              <li><router-link class="dropdown-item" to="/financialinfo/info">{{ $t('navbar.KeyInfo') }}</router-link>
              </li>
              <li><router-link class="dropdown-item" to="/financialinfo/statements">{{ $t('navbar.Statements')
              }}</router-link></li>
              <li><router-link class="dropdown-item" to="/financialinfo/description">{{ $t('navbar.MDNA') }}</router-link>
              </li>
            </ul>
          </li>

          <!-- ราคาหลักทรัพย์ -->
          <li class="nav-item dropdown">
            <a class="nav-link" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              {{ $t('navbar.StockPriceInfo') }}
            </a>
            <ul class="dropdown-menu shadow-dropdown">
              <li><router-link class="dropdown-item" to="/stockpriceinfo/info">{{ $t('navbar.StockPrice') }}</router-link>
              </li>
              <li>
                <a class="dropdown-item" href="https://www.set.or.th/th/market/product/stock/quote/ORI/historical-trading"
                  target="_blank" rel="noopener noreferrer">
                  {{ $t('navbar.HistoricalPrice') }}
                </a>
              </li>
            </ul>

          </li>

          <!-- ข้อมูลผู้ถือหุ้น -->
          <li class="nav-item dropdown">
            <a class="nav-link" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              {{ $t('navbar.ShareholderInfo') }}
            </a>
            <ul class="dropdown-menu shadow-dropdown">
              <li><router-link class="dropdown-item" to="/basicInfo/info">{{ $t('navbar.BasicInfo') }}</router-link></li>
              <li><router-link class="dropdown-item" to="/basicinfo/majorshareholders">{{ $t('navbar.MajorShareholders')
              }}</router-link></li>
              <li><router-link class="dropdown-item" to="/basicinfo/dividendpayment">{{ $t('navbar.Dividend')
              }}</router-link></li>
              <li><router-link class="dropdown-item" to="/basicinfo/shareholdermeeting">{{ $t('navbar.Meeting')
              }}</router-link></li>
              <li><router-link class="dropdown-item" to="/basicinfo/sharesubscription">{{ $t('navbar.Subscription')
              }}</router-link></li>
              <li><router-link class="dropdown-item" to="/warrantholdersinfo">{{ $t('navbar.WarrantInfo') }}</router-link>
              </li>
            </ul>
          </li>

          <!-- ข้อมูลตราสารหนี้ -->
          <li class="nav-item dropdown">
            <a class="nav-link" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              {{ $t('navbar.DebtInfo') }}
            </a>
            <ul class="dropdown-menu shadow-dropdown">
              <li><router-link class="dropdown-item" to="/debtinfo/info">{{ $t('navbar.DebtInfo') }}</router-link></li>
              <li><router-link class="dropdown-item" to="/debtinfo/creditrating">{{ $t('navbar.CreditRating')
              }}</router-link></li>
              <li><router-link class="dropdown-item" to="/debtinfo/billexchange">{{ $t('navbar.BillExchange')
              }}</router-link></li>
            </ul>
          </li>

          <!-- ข่าวสาร -->
          <li class="nav-item dropdown">
            <a class="nav-link" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              {{ $t('navbar.NewsCenter') }}
            </a>
            <ul class="dropdown-menu shadow-dropdown">
              <li><router-link class="dropdown-item" to="/newinfo/info">{{ $t('navbar.SETNews') }}</router-link></li>
              <li><router-link class="dropdown-item" to="/newinfo/newsmedia">{{ $t('navbar.Press') }}</router-link></li>
              <li><router-link class="dropdown-item" to="/newinfo/newsprintmedia">{{ $t('navbar.PrintNews')
              }}</router-link></li>
              <li><router-link class="dropdown-item" to="/newinfo/electronicadvertising">{{ $t('navbar.EAd')
              }}</router-link></li>
              <li><router-link class="dropdown-item" to="/calendarinfo/info">{{ $t('navbar.Calendar') }}</router-link>
              </li>
            </ul>
          </li>

          <!-- เอกสารเผยแพร่ -->
          <li class="nav-item dropdown">
            <a class="nav-link" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              {{ $t('navbar.PublishedDocs') }}
            </a>
            <ul class="dropdown-menu shadow-dropdown">
              <li>
                <router-link class="dropdown-item" to="/activityinfo">{{ $t('navbar.Presentation') }}</router-link>
              </li>
              <li><router-link class="dropdown-item" to="/publisheddocsinfo/info">{{ $t('navbar.OneReport')
              }}</router-link></li>
              <li><router-link class="dropdown-item" to="/publisheddocsinfo/annualreport">{{ $t('navbar.Annual')
              }}</router-link></li>
              <li><router-link class="dropdown-item" to="/publisheddocsinfo/sustainabilityreport">{{
                $t('navbar.SustainabilityReport') }}</router-link></li>
              <li><router-link class="dropdown-item" to="/publisheddocsinfo/form56-1">{{ $t('navbar.Form561')
              }}</router-link></li>
            </ul>
          </li>

          <li class="nav-item">
            <a class="nav-link"
              href="https://origin.co.th/corporate/about-origin-property/driving-business/sustainability-management/"
              target="_blank">{{ $t('navbar.Sustainability') }}</a>
          </li>


          <!-- Presentation -->
          <!-- <li class="nav-item">
            <router-link class="nav-link" to="/activityinfo">{{ $t('navbar.Presentation') }}</router-link>
          </li> -->

          <!-- Analyst -->
          <li class="nav-item dropdown">
            <a class="nav-link" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              {{ $t('navbar.AnalystInfo') }}
            </a>
            <ul class="dropdown-menu shadow-dropdown">
              <li><router-link class="dropdown-item" to="/analystinfo">{{ $t('navbar.ContactAnalyst') }}</router-link>
              </li>
              <li><router-link class="dropdown-item" to="/securitiesanalysis">{{ $t('navbar.SecuritiesAnalysis')
              }}</router-link></li>
            </ul>
          </li>

          <!-- Contact -->
          <li class="nav-item dropdown">
            <a class="nav-link" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              {{ $t('navbar.ContactInfo') }}
            </a>
            <ul class="dropdown-menu shadow-dropdown">
              <li><router-link class="dropdown-item" to="/informationinfo">{{ $t('navbar.ContactIR') }}</router-link></li>
              <li><router-link class="dropdown-item" to="/receiveemails">{{ $t('navbar.SubscribeEmail') }}</router-link>
              </li>
            </ul>
          </li>
        </ul>

        <!-- Language Switcher -->
        <!-- <div class="d-flex justify-content-end align-items-center p-2">
          <div class="dropdown">
            <button class="btn btn-outline-secondary btn-sm dropdown-toggle" type="button" id="languageDropdown"
              data-bs-toggle="dropdown" aria-expanded="false">
              {{ selectedLanguageText }}
            </button>
            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="languageDropdown">
              <li><a class="dropdown-item" @click="selectLanguage('en')">English</a></li>
              <li><a class="dropdown-item" @click="selectLanguage('th')">ไทย</a></li>
            </ul>
          </div>
        </div> -->
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'AppNavbarMenu',
  data() {
    return {
      selectedLanguage: 'th',
    };
  },
  computed: {
    selectedLanguageText() {
      return this.selectedLanguage === 'en' ? 'English' : 'ไทย';
    }
  },
  methods: {
    selectLanguage(language) {
      this.selectedLanguage = language;
      this.$i18n.locale = language;
    },
  },
};
</script>

<style scoped>
.shadow-dropdown.show {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  border: none
}

.navbar-nav .nav-link {
  font-size: 0.74rem;
  position: relative;
  text-decoration: none;
  margin-right: 13px;
}


.dropdown-menu .dropdown-item {
  font-size: 0.74rem;
  text-decoration: none;
}

.navbar-nav>.nav-item>.nav-link::after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  bottom: 0;
  left: 0;
  background-color: #E87D2E;
  transition: width 0.3s;
}

.navbar-nav>.nav-item>.nav-link:hover::after {
  width: 100%;
}

.navbar-toggler {
  margin-left: auto;
  /* Push it to the right */
}

a.router-link-active,
a.router-link-exact-active {
  text-decoration: none;
  color: #E87D2E;
}

.navbar-home {
  justify-self: center;
}


@media (max-width: 990px) {
  .navbar-home {
    /* Add mobile-specific styling */
    justify-self: auto;
    /* Example: align navbar to the start for mobile */
  }
}
</style>